import React, { useEffect, useMemo, useState } from 'react';
import { Container, Text } from '@pixi/react';
import { boostedJackpotDateHelper } from '../../../../core/helpers/timeHelper';
import { applicationStore } from '../../../../store/applicationStore';
import { boostedJackpotStore } from '../../../../store/boostedJackpotStore';
import { userSettingsStore } from '../../../../store/userSettingsStore';
import { gameStore } from '../../../../store/gameStore';

let intervalId;

function BoostedJackpotPopupDate({
  x,
  y,
  isIcon = false,
  stylesTimer,
  marginInContainer,
  marginInText,
  hiderTextXPosition,
  durationTextPositions,
}) {
  const {
    canvasTranslationKeys: { DAYS, HOURS, MINUTES, SECONDS, DURATION },
  } = applicationStore;

  const { days, hours, minutes, seconds } = boostedJackpotDateHelper();
  const [dayTime, setDayTime] = useState(days);
  const [hoursTime, setHoursTime] = useState(hours);
  const [minutesTime, setMinutesTime] = useState(minutes);
  const [secondsTime, setSecondsTime] = useState(seconds);

  useEffect(() => {
    if (!+days && !+hours && !+minutes && !+seconds) {
      gameStore.setIsSpinStart(false);
      boostedJackpotStore.setIsBoostedJackpot(false);
      userSettingsStore.setIsBoostedJackpotInitialPopup(false);
    }
  }, [days, hours, minutes, seconds]);

  useEffect(() => {
    intervalId = setInterval(() => {
      setDayTime(boostedJackpotDateHelper().days);
      setHoursTime(boostedJackpotDateHelper().hours);
      setMinutesTime(boostedJackpotDateHelper().minutes);
      setSecondsTime(boostedJackpotDateHelper().seconds);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const stylesHider = useMemo(() => {
    return {
      _fontSize: isIcon ? 9 : 11,
      _fontWeight: 700,
      _fontFamily: 'poppinsMedium',
      _fill: '#FFFFFF',
      align: 'center',
    };
  }, [isIcon]);

  const dateTime = useMemo(() => {
    return [
      (+days || !isIcon) && [
        { text: days[0], textY: 60, textX: 0, stylesTimer },
        { text: days[1], textY: 60, textX: marginInText, stylesTimer },
        {
          text: DAYS,
          textY: isIcon ? 75 : 98,
          textX: hiderTextXPosition,
          stylesHider,
        },
      ],
      (+hours || +days || !isIcon) && [
        { text: hours[0], textY: 60, textX: 0, stylesTimer },
        { text: hours[1], textY: 60, textX: marginInText, stylesTimer },
        {
          text: HOURS,
          textY: isIcon ? 75 : 98,
          textX: hiderTextXPosition,
          stylesHider,
        },
      ],
      (!+days || !isIcon) && [
        { text: minutes[0], textY: 60, textX: 0, stylesTimer },
        { text: minutes[1], textY: 60, textX: marginInText, stylesTimer },
        {
          text: MINUTES,
          textY: isIcon ? 75 : 98,
          textX: hiderTextXPosition,
          stylesHider,
        },
      ],
      ((!+days && !+hours) || !isIcon) && [
        { text: seconds[0], textY: 60, textX: 0, stylesTimer },
        { text: seconds[1], textY: 60, textX: marginInText, stylesTimer },
        {
          text: SECONDS,
          textY: isIcon ? 75 : 98,
          textX: hiderTextXPosition,
          stylesHider,
        },
      ],
    ];
  }, [
    days,
    DAYS,
    hours,
    HOURS,
    isIcon,
    dayTime,
    minutes,
    MINUTES,
    SECONDS,
    seconds,
    hoursTime,
    stylesHider,
    minutesTime,
    secondsTime,
    marginInText,
    marginInContainer,
    hiderTextXPosition,
  ]);

  const newDateTime = useMemo(() => {
    return isIcon ? dateTime.filter((el) => el.length) : dateTime;
  }, [isIcon, dateTime]);

  return (
    <Container x={x} y={y} name='BoostedJackpotPopupDate'>
      {!isIcon && (
        <Text
          x={durationTextPositions.x}
          y={durationTextPositions.y}
          text={DURATION}
          anchor={0.5}
          style={{
            fontSize: 10,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
            fill: '#FFFFFF',
            align: 'center',
          }}
          resolution={2}
        />
      )}
      {newDateTime.map((times, index) => {
        return (
          <Container key={`${index}`.concat('id')} x={index * marginInContainer}>
            {/* eslint-disable-next-line no-shadow,no-unused-vars */}
            {times.map(({ text, textX, textY, stylesTimer, stylesHider }, i) => {
              return (
                <Text
                  x={textX}
                  y={textY}
                  text={text}
                  anchor={0.5}
                  key={`${i}`.concat('time')}
                  style={stylesHider || stylesTimer}
                  resolution={2}
                />
              );
            })}
          </Container>
        );
      })}
    </Container>
  );
}

export default BoostedJackpotPopupDate;
